var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatbotPointerRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_323_1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28C8 14.7452 18.7452 4 32 4C45.2548 4 56 14.7452 56 28V52H32C18.7452 52 8 41.2548 8 28Z",
    fill: "white",
    stroke: "#003893",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.9998,
    cy: 27.9999,
    r: 22.9091,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8926 12.009V15.9067C31.8926 16.0175 31.9358 16.1237 32.0126 16.202C32.0895 16.2803 32.1937 16.3243 32.3023 16.3243C32.411 16.3243 32.5152 16.2803 32.592 16.202C32.6689 16.1237 32.712 16.0175 32.712 15.9067V12.009C32.712 11.8982 32.6689 11.792 32.592 11.7137C32.5152 11.6354 32.411 11.5914 32.3023 11.5914C32.1937 11.5914 32.0895 11.6354 32.0126 11.7137C31.9358 11.792 31.8926 11.8982 31.8926 12.009Z",
    fill: "#003336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9917 28.318C17.9969 26.2964 18.5346 24.3134 19.5485 22.576C18.4488 22.639 17.4052 23.092 16.5987 23.8567C15.4516 25.0208 15.4024 26.5425 15.3297 28.747C15.2535 31.0068 15.2047 32.4947 16.2587 33.6645C17.2851 34.865 18.6974 34.9394 20.0462 34.8617C18.7171 32.9479 17.9997 30.6627 17.9917 28.318Z",
    fill: "#6CF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2687 28.7464C49.196 26.542 49.1457 25.0202 47.9997 23.8562C47.1932 23.0915 46.1496 22.6384 45.0499 22.5755C46.1473 24.4509 46.6846 26.6117 46.5959 28.7935C46.5073 30.9754 45.7966 33.0835 44.5509 34.86C45.9023 34.9383 47.3095 34.865 48.3384 33.6629C49.3924 32.4947 49.3435 31.0068 49.2687 28.7464Z",
    fill: "#6CF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6053 28.3179C46.6053 21.3218 40.1999 15.6503 32.2985 15.6503C24.3971 15.6503 17.9917 21.3218 17.9917 28.3179C17.9917 33.8616 22.0152 38.5704 27.6162 40.2879C27.2229 41.0953 26.5958 41.8319 25.7639 42.83C25.5572 43.0783 25.4335 43.3872 25.4108 43.712C25.388 44.0368 25.4675 44.3605 25.6376 44.6361C25.8076 44.9117 26.0595 45.1249 26.3565 45.2447C26.6535 45.3645 26.9803 45.3847 27.2893 45.3023C30.1137 44.5414 32.6706 42.9844 34.6665 40.8099C41.4405 39.8101 46.6053 34.5997 46.6053 28.3179Z",
    fill: "#00CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2985 13.3835C33.0527 13.3835 33.6642 12.7603 33.6642 11.9915C33.6642 11.2227 33.0527 10.5994 32.2985 10.5994C31.5443 10.5994 30.9329 11.2227 30.9329 11.9915C30.9329 12.7603 31.5443 13.3835 32.2985 13.3835Z",
    fill: "#003893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2985 17.7384C25.5582 17.7384 20.762 23.7047 21.4713 30.4734C21.597 31.7122 22.1676 32.8599 23.0736 33.6955C23.9795 34.5312 25.1566 34.9957 26.3784 34.9998C29.3386 34.9914 29.3386 33.3157 32.2985 33.3157C35.2584 33.3157 35.2584 34.9914 38.2186 34.9998C39.4404 34.9957 40.6175 34.5312 41.5235 33.6955C42.4294 32.8599 43.0001 31.7122 43.1257 30.4734C43.835 23.7047 39.0388 17.7384 32.2985 17.7384Z",
    fill: "#003893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2985 37.6447C32.9773 37.6447 33.5276 37.0837 33.5276 36.3918C33.5276 35.6999 32.9773 35.139 32.2985 35.139C31.6197 35.139 31.0694 35.6999 31.0694 36.3918C31.0694 37.0837 31.6197 37.6447 32.2985 37.6447Z",
    fill: "#003893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8182 27.5824C34.5844 27.3535 34.2722 27.2266 33.9481 27.2284C33.6239 27.2303 33.3132 27.3609 33.0819 27.5925C32.9903 27.7124 32.8731 27.8096 32.7392 27.8764C32.6053 27.9433 32.4581 27.9781 32.309 27.9783C32.1599 27.9785 32.0127 27.944 31.8786 27.8775C31.7445 27.811 31.627 27.7142 31.5352 27.5944C31.4219 27.4772 31.287 27.384 31.1383 27.3199C30.9896 27.2559 30.83 27.2223 30.6686 27.2211C30.5072 27.2199 30.3471 27.2512 30.1975 27.313C30.0479 27.3749 29.9118 27.4662 29.7968 27.5817C29.6819 27.6973 29.5904 27.8347 29.5275 27.9863C29.4647 28.1379 29.4318 28.3006 29.4306 28.4651C29.4294 28.6296 29.4601 28.7928 29.5208 28.9453C29.5815 29.0977 29.6711 29.2365 29.7844 29.3537C30.1059 29.7088 30.496 29.9922 30.9303 30.186C31.3645 30.3798 31.8334 30.4799 32.3075 30.4799C32.7815 30.4799 33.2504 30.3798 33.6846 30.186C34.1189 29.9922 34.509 29.7088 34.8305 29.3537C35.0572 29.116 35.183 28.797 35.1807 28.4655C35.1784 28.134 35.0482 27.8168 34.8182 27.5824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1711 23.663C38.1748 23.4951 38.1459 23.3282 38.086 23.1718C38.0261 23.0155 37.9365 22.8727 37.8222 22.7518C37.708 22.6309 37.5714 22.5342 37.4203 22.4674C37.2693 22.4005 37.1067 22.3648 36.942 22.3622C36.6164 22.3634 36.3045 22.4958 36.0742 22.7305C35.844 22.9652 35.7141 23.2832 35.713 23.6151V25.5639C35.7133 25.8961 35.8429 26.2146 36.0733 26.4494C36.3038 26.6843 36.6162 26.8164 36.942 26.8168C37.1068 26.8147 37.2695 26.7792 37.4208 26.7125C37.572 26.6458 37.7087 26.5492 37.8231 26.4282C37.9374 26.3073 38.027 26.1644 38.0868 26.0079C38.1465 25.8513 38.1752 25.6843 38.1711 25.5163C38.1711 25.0531 38.1711 24.1262 38.1711 23.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6556 22.3622C27.4909 22.3647 27.3283 22.4004 27.1772 22.4672C27.0261 22.534 26.8895 22.6307 26.7753 22.7516C26.661 22.8725 26.5713 23.0153 26.5115 23.1718C26.4516 23.3282 26.4228 23.4951 26.4265 23.663C26.4279 24.1262 26.4279 25.0531 26.4265 25.5163C26.4228 25.6842 26.4518 25.8511 26.5116 26.0074C26.5715 26.1638 26.6612 26.3065 26.7754 26.4274C26.8897 26.5483 27.0263 26.645 27.1773 26.7118C27.3284 26.7786 27.491 26.8143 27.6556 26.8168C27.9813 26.8157 28.2933 26.6833 28.5235 26.4486C28.7538 26.2139 28.8836 25.8959 28.8847 25.5639V23.6151C28.8836 23.2832 28.7537 22.9652 28.5234 22.7305C28.2932 22.4958 27.9812 22.3634 27.6556 22.3622Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_323_1338",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_323_1338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_323_1338",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_1338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.9607,
    height: 35.6364,
    fill: "white",
    transform: "translate(14.8182 10.1818)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotPointerRight);
export default __webpack_public_path__ + "static/media/Chatbot_pointer_right.a2d30de61801e230624646d73baaa18f.svg";
export { ForwardRef as ReactComponent };